import React from 'react'

import BaseLayout from '../components/BaseLayout'

const NotFoundPage = () => (
  <BaseLayout>
    <h1>NOT FOUND</h1>
    <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
  </BaseLayout>
)

export default NotFoundPage
